###
Authenticate and fetch the customer on load
###
export hydrateCustomer = (store) ->

	# Return promise that resolves when the user is hydrated
	return store.dispatch 'customer/loginFromStorage'
